module.exports = __webpack_public_path__ + "static/media/report-grey.9e126030.svg";